module.exports = __webpack_public_path__ + "img/out.e2c8ff33.svg";